import { render } from "./DashboardEditProfile.vue?vue&type=template&id=a2025ee6&scoped=true"
import script from "./DashboardEditProfile.vue?vue&type=script&lang=js"
export * from "./DashboardEditProfile.vue?vue&type=script&lang=js"

import "./DashboardEditProfile.vue?vue&type=style&index=0&id=a2025ee6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2025ee6"]])

export default __exports__